import { Alert, Button, Chip, CircularProgress, Container } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useCallback, useEffect, useState } from "react";
import { ASSET_STATUS_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import AppTableView from "../AppTableView";
import { useAlert } from "../alerts/AlertContext";
import AssetStatusDialog from "./AssetStatusDialog";

const statusColors = {
  open: "#007BFF",
  "in-progress": "#FD7E14",
  hold: "#FFC107",
  resolved: "#20C997",
  closed: "#6C757D",
};

function AssetStatus() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const showAlert = useAlert();

  const getAssetStatusData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await AxiosInstance.get(ASSET_STATUS_URL);
      setData(response.data || []);
    } catch (error) {
      console.error("Error fetching Asset Status data:", error);
      setError("Failed to load Asset Status data. Please try again.");
      // showAlert("Failed to load statuses", "error");
    } finally {
      setLoading(false);
    }
  }, [showAlert]);

  useEffect(() => {
    getAssetStatusData();
  }, [getAssetStatusData]);

  const columns = [
    {
      field: "id",
      flex: 1,
      headerName: "Status Id",
      renderCell: (params) => params.value,
    },
    {
      field: "name",
      flex: 2,
      headerName: "Name",
      renderCell: (params) => params.value,
    },
    {
      field: "color",
      flex: 1,
      headerName: "Color",
      renderCell: (params) => params.value,
    },    
    {
      field: "description",
      flex: 1,
      headerName: "Description",
       renderCell: (params) => params.value,
    },
    {
      field: "action",
      flex: 1,
      headerName: "Actions",
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <AssetStatusDialog
            assetStatusId={params.row.id}
            assetStatusName="Edit"
            variant="link"
          />
        </Box>
      ),
    },
  ];

  //if error content
  if (error) {
    return (
      <Container>
        <Alert
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={getAssetStatusData}>
              Retry
            </Button>
          }
          sx={{ borderRadius: 2 }}
        >
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Box
      sx={{
        borderRadius: "8px",
        overflow: "hidden",
        p: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      {/* loading or content */}
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <AppTableView rows={data} cols={columns} initialPageSize={5} />
      )}
    </Box>
  );
}

export default AssetStatus;
